// ─── Imports ────────────────────────────────────────────────────────────────
import { STUDY } from "../constants";
import { instance } from "../../axios";

// ─── Actions: Get Studies ────────────────────────────────────────────────────
let getStudies = () => {
  return (dispatch) => {
    dispatch({
      type: STUDY.STUDY_GET_ALL,
    });
    instance({
      method: "GET",
      url: "/study",
    })
      .then((results) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let getStudiesBySponsor = (sponsorId) => {
  return (dispatch) => {
    dispatch({
      type: STUDY.STUDY_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/study/sponsor/${sponsorId}`,
    })
      .then((results) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let getStudiesBySponsorUser = (userId) => {
  return (dispatch) => {
    dispatch({
      type: STUDY.STUDY_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/study/sponsor-user/${userId}`,
    })
      .then((results) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let getStudiesByEmployee = (userId) => {
  return (dispatch) => {
    dispatch({
      type: STUDY.STUDY_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/study/employee/${userId}`,
    })
      .then((results) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let getStudiesByUser = (userId) => {
  return (dispatch) => {
    dispatch({
      type: STUDY.STUDY_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/study/user/${userId}`,
    })
      .then((results) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STUDY.STUDY_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

// ─── Actions: Create/Update Study ─────────────────────────────────────────────
let createStudy = (body) => {
  return (dispatch) => {
    dispatch({
      type: STUDY.STUDY_CREATE,
    });
    instance
      .post("/study", body)
      .then((results) => {
        dispatch({
          type: STUDY.STUDY_CREATE_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STUDY.STUDY_CREATE_FAILURE,
          payload: error,
        });
      });
  };
};

let updateStudy = (id, body) => {
  return (dispatch) => {
    dispatch({
      type: STUDY.STUDY_UPDATE,
    });
    instance
      .put(`/study/${id}`, body)
      .then((results) => {
        dispatch({
          type: STUDY.STUDY_UPDATE_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STUDY.STUDY_UPDATE_FAILURE,
          payload: error,
        });
      });
  };
};

let updateStudyExports = (studyId, body) => {
  return async (dispatch) => {
    dispatch({
      type: STUDY.STUDY_UPDATE,
    });

    try {
      const results = await instance.put(
        `/study/configure-exports/${studyId}`,
        body
      );
      dispatch({
        type: STUDY.STUDY_UPDATE_SUCCESS,
        payload: results.data,
      });
    } catch (error) {
      dispatch({
        type: STUDY.STUDY_UPDATE_FAILURE,
        payload: error,
      });
    }
  };
};

// ─── Actions: Check/Reset Study ───────────────────────────────────────────────
const checkStudyExports = (studyId) => {
  return async (dispatch) => {
    dispatch({
      type: STUDY.STUDY_GET_ONE,
    });
    try {
      const response = await instance({
        method: "GET",
        url: `/study/${studyId}/has-exports`,
      });
      const hasExports = response.data.hasExports;
      dispatch({
        type: STUDY.STUDY_GET_ONE_SUCCESS,
        payload: hasExports,
      });
      return hasExports;
    } catch (error) {
      console.error("Error checking study exports:", error);

      dispatch({
        type: STUDY.STUDY_GET_ONE_FAILURE,
        payload: error,
      });

      return false;
    }
  };
};

const getStudyInfo = (studyId) => {
  return (dispatch) => {
    dispatch({
      type: STUDY.STUDY_GET_ONE,
    });
    instance({
      method: "GET",
      url: `/study/${studyId}/info`,
    })
      .then((results) => {
        dispatch({
          type: STUDY.STUDY_GET_ONE_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STUDY.STUDY_GET_ONE_FAILURE,
          payload: error,
        });
      });
  };
};

const resetStudy = () => {
  return {
    type: STUDY.STUDY_CLEAR,
  };
};

// ─── Exports ─────────────────────────────────────────────────────────────────
export {
  createStudy,
  getStudies,
  getStudiesBySponsor,
  getStudiesBySponsorUser,
  getStudiesByEmployee,
  getStudiesByUser,
  updateStudy,
  resetStudy,
  getStudyInfo,
  updateStudyExports,
  checkStudyExports,
};
